import PageMeta from "../../components/common/PageMeta";
import AuthLayout from "./AuthPageLayout";
import SignUpForm from "../../components/auth/SignUpForm";

const SignUp = () => {
  return (
    <>
      <PageMeta
        title="Free QR code for cafe, restaurant and bar | GetEat"
        description="This is GetEat SignUp page, where you can create you own QR code menu for your restaurant, cafe or bar. Sign up for your account and start creating your menu."
      />
      <AuthLayout>
        <SignUpForm />
      </AuthLayout>
    </>
  );
}

export default SignUp;
